module.exports = __webpack_public_path__ + "static/media/qr-code.726ea939.png";